import SideMenu from './side-menu.vue'
export default SideMenu



// WEBPACK FOOTER //
// ./src/components/main/components/side-menu/index.js